import { render } from "./Carousel.vue?vue&type=template&id=5cf8a391"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=5cf8a391&lang=css"

import exportComponent from "/home/tchery/dev/assiette-parfaite/frontend-gesit/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__